import axios from "axios";
import React, { useEffect } from "react";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const Home = () => {
  const token = JSON.parse(localStorage.getItem("admin-token"));

  const [dashboard, setDashboard] = React.useState({});

  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          setDashboard(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token]);

  const isEmpty = Object.keys(dashboard).length === 0;

  return (
    <>
      {isEmpty && <Spinner />}
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        <div className="container mx-auto px-6 py-8">
          <h3 className="text-gray-700 text-3xl font-medium">Dashboard</h3>

          <div className="mt-4">
            <div className="flex flex-wrap -mx-6">
              <div className="w-full px-6 mb-10 sm:w-1/2 xl:w-1/3">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md bg-indigo-300">
                  <div className="p-3">
                    <i className="fas fa-users h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {dashboard.all_users}
                    </h4>
                    <div className="text-gray-500">All Users</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 px-6 mb-10 sm:w-1/2 xl:w-1/3 sm:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fas fa-shopping-basket h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      all_orders_list
                    </h4>
                    <div className="text-gray-500">Total Orders</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 mb-10 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fab fa-product-hunt h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {dashboard.all_products}
                    </h4>
                    <div className="text-gray-500">Available Products</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 mb-10 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-brands fa-blogger h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {dashboard.all_blogs_list}
                    </h4>
                    <div className="text-gray-500">Available Blogs</div>
                  </div>
                </div>
              </div>
              <div className="w-full mt-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-comment h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      all_feedback_list
                    </h4>
                    <div className="text-gray-500">Available Feedbacks</div>
                  </div>
                </div>
              </div>
              <div className="w-full mt-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-vials h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {dashboard.all_labtests}
                    </h4>
                    <div className="text-gray-500">Available Lab Tests</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-stethoscope h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      all_medical_request_list
                    </h4>
                    <div className="text-gray-500">All Medical Request</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-book h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      all_uploaded_prescription_list
                    </h4>
                    <div className="text-gray-500">All Prescription Upload</div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-disease h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {" "}
                      all_specialist_list{" "}
                    </h4>
                    <div className="text-gray-500">All Specialities</div>
                  </div>
                </div>
              </div>

              <div className="w-full py-6 px-6 sm:w-1/2 xl:w-1/3 xl:mt-0">
                <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-indigo-300">
                  <div className="p-3">
                    <i className="fa-solid fa-calendar-check h-8 w-8 text-3xl"></i>
                  </div>

                  <div className="mx-5">
                    <h4 className="text-2xl font-semibold text-gray-700">
                      {" "}
                      all_appointment_list{" "}
                    </h4>
                    <div className="text-gray-500">All Appointment</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8"></div>
        </div>
      </main>
    </>
  );
};

export default Home;
